import React from "react";
import { makeStyles } from "@mui/styles";
import { Box, Grid, Typography } from "@mui/material";
import CustomSelect from "../../common/CustomSelect";

const useStyles = makeStyles(theme => ({
  card: {
    padding: 15,
    borderRadius: 4,
    border: "1px solid #e6e6e6",
    marginBottom: 10,
    "& .MuiInputBase-root": {
      marginTop: 5,
    },
    "& .MuiTextField-root": {
      marginTop: 0,
    },
    "& .MuiCheckbox-root": {
      padding: "4px 9px",
    },
  },
  heading: {
    fontSize: 14,
    fontWeight: 600,
  },
  labelWrap: {
    display: "flex",
    alignItems: "center",
    "& .MuiTextField-root": {
      width: "auto",
      marginLeft: 15,
    },
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
  },
  subLabel: {
    fontSize: 12,
    marginLeft: "auto",
  },
  text: {
    fontSize: 12,
    marginBottom: 10,
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  greenLink: {
    fontSize: 12,
    color: theme.palette.primary.main,
    padding: 0,
    textTransform: "none",
    fontWeight: 600,
    marginLeft: 20,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  icon: {
    width: "unset",
    height: "unset",
    overflow: "unset",
    fontSize: 12,
    marginRight: 8,
    marginTop: 3,
  },
  grayLink: {
    fontSize: 12,
    color: "#555",
    padding: 0,
    textTransform: "none",
    fontWeight: 600,
    marginLeft: 20,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  blueLink: {
    fontSize: 12,
    color: theme.palette.common.link,
    padding: 0,
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "transparent",
      opacity: 0.8,
    },
  },
  child: {
    paddingLeft: 27,
  },
}));

const AddressDisplay = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box className={classes.card}>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <Typography className={classes.heading}>
                Display of addresses
              </Typography>
            </Grid>
          </Grid>
          <Box mt={2} mb={1} />
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} />
            <Grid item xs={12} md={3} align="center">
              <Typography className={classes.label}>
                Delivery Address
              </Typography>
            </Grid>
            <Grid item xs={12} md={3} align="center">
              <Typography className={classes.label}>
                Purchaser Address
              </Typography>
            </Grid>
            <Grid item xs={12} md={3} align="center">
              <Typography className={classes.label}>Invoice Address</Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Company Name</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Receiver</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Street Address</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Address2</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Zip code</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>City</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Country</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>E-mail</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Phone</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Contact</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={2} align="right">
              <Typography className={classes.label}>Customer number</Typography>
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
            <Grid item xs={12} md={3}>
              <CustomSelect options={[{ label: "Default", value: 1 }]} />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AddressDisplay;
